export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAAAtAQMAAAAUQe44AAAAA1BMVEX5v1L7V/cqAAAADklEQVQoz2MYBaOAGgAAAkkAAQmr4rUAAAAASUVORK5CYII="